import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'Event',
})
export class EventPipe implements PipeTransform {
  transform(items: any[], dateModelSearch: any): any[] {
    if (!items) {
      return []
    }
    if (!dateModelSearch) {
      return items
    }
    return items.filter(item => {
      return (
        item.date.start >= dateModelSearch.start &&
        item.date.start <= dateModelSearch.end
      )
    })
  }
}
